/**
 * jump-list
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module template
import './_jump-list.twig';
import './_jump-list.css';

export const name = 'jump-list';

export const defaults = {
  dummyClass: 'js-jump-list-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { jumpList = {} }) {
  // Find our component within the DOM
  const $jumpList = $('.jump-list', $context);
  // Bail if component does not exist
  if (!$jumpList.length) {
    return;
  }
  // Merge defaults with incoming settings
  // eslint-disable-next-line no-unused-vars
  const settings = {
    ...defaults,
    ...jumpList,
  };

  // Adds click handlers to control the scroll for the items in the menu
  $('.jump-list__link', $jumpList).click(function handleJumpListClick(e) {
    e.preventDefault();
    const id = $(this).attr('href');

    // If id or element not exist on page.
    if (!id || !$(id).length) {
      return;
    }

    const elementOffset = $(id).offset();
    if (elementOffset && elementOffset.top) {
      window.history.pushState(null, null, id);
      window.scrollTo({
        top: elementOffset.top - 100,
        behavior: 'smooth',
      });
    }
  });
}

export default enable;
